var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import css from '@styled-system/css';
import { themeGet } from '@styled-system/theme-get';
import React, { forwardRef, useState } from 'react';
import styled from 'styled-components';
import { alignSelf, compose, space } from 'styled-system';
import Box from './Box';
import theme from '../theme';
function focusedStyles(props) {
    if (!props.focus) {
        return;
    }
    return css({
        boxShadow: `0 0 1px 1px ${themeGet('colors.gray.2', 'lightgray')(props)}`
    });
}
function disabledStyles(props) {
    if (!props.disabled) {
        return;
    }
    return css({
        color: 'gray.3',
        cursor: 'not-allowed'
    });
}
function disabledRadioStyles(props) {
    if (!props.disabled) {
        return;
    }
    return css({
        backgroundColor: 'gray.5',
        cursor: 'not-allowed'
    });
}
function selectedOuterStyles(props) {
    let color = props.color || 'brand';
    color = themeGet(`colors.${color}`, color)(props);
    return css({
        borderColor: color
    });
}
function selectedInnerStyles() {
    return css({
        display: 'block'
    });
}
const StyledRadioButton = styled(Box) `
  ${css({
    alignItems: 'center',
    cursor: 'pointer',
    flexDirection: 'row',
    width: 'fit-content'
})}
  ${disabledStyles}
  ${compose(alignSelf, space)}
`;
const OuterRadio = styled(Box) `
  ${css({
    cursor: 'pointer',
    flexDirection: 'row',
    flexShrink: 0,
    position: 'relative',
    top: '0',
    left: '0',
    height: '16px',
    width: '16px',
    borderRadius: '50%',
    borderWidth: '1',
    borderColor: 'gray.3',
    borderStyle: 'solid',
    marginRight: '2'
})}
  ${focusedStyles}
  ${disabledRadioStyles}
`;
const InnerRadio = styled.span `
  ${props => {
    let color = props.color || 'brand';
    color = themeGet(`colors.${color}`, color)(props);
    return css({
        cursor: 'pointer',
        backgroundColor: color,
        content: '',
        position: 'absolute',
        display: 'none',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: '8px',
        height: '8px',
        borderRadius: '50%'
    });
}}
`;
const StyledInput = styled.input `
  ${css({
    cursor: 'pointer',
    position: 'absolute',
    opacity: '0',
    zIndex: '1'
})}
  &:disabled {
    ${css({
    cursor: 'not-allowed'
})}
  }
  &:checked ~ ${OuterRadio} {
    ${selectedOuterStyles}
  }
  &:checked ~ ${OuterRadio} > ${InnerRadio} {
    ${selectedInnerStyles}
  }
`;
const StyledLabel = styled.label `
  ${css({
    cursor: 'pointer',
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center'
})}
  ${disabledStyles}
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
`;
const Radio = forwardRef((_a, ref) => {
    var { id, name, checked, children, color, defaultChecked, disabled, value, onChange, theme } = _a, rest = __rest(_a, ["id", "name", "checked", "children", "color", "defaultChecked", "disabled", "value", "onChange", "theme"]);
    const [focus, setFocus] = useState(false);
    return (React.createElement(StyledRadioButton, Object.assign({ disabled: disabled }, rest),
        React.createElement(StyledInput, { id: id, name: name, checked: checked, color: color, defaultChecked: defaultChecked, disabled: disabled, onChange: onChange, ref: ref, type: 'radio', value: value, onFocus: () => setFocus(true), onBlur: () => setFocus(false) }),
        React.createElement(OuterRadio, { focus: focus, disabled: disabled },
            React.createElement(InnerRadio, { color: color })),
        React.createElement(StyledLabel, { htmlFor: id, disabled: disabled }, children)));
});
Radio.defaultProps = { theme };
Radio.displayName = 'Radio';
export default Radio;
//# sourceMappingURL=Radio.js.map